module.exports = __webpack_public_path__ + "static/media/StripesUp.44cbeed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/GraphicalTools/StripesUp.svg
// module id = 1994
// module chunks = 103